












import Vue from "vue";
import MenuTop from "./components/menu-top/MenuTop.vue";
import MenuLeft from "./components/menu-left/MenuLeft.vue";
import Grapher from "./components/grapher/Grapher.vue";
import MenuRight from "./components/menu-right/MenuRight.vue";
import MenuBottomTools from "./components/menu-bottom/MenuBottomTools.vue";
import MenuBottomUndo from "./components/menu-bottom/MenuBottomUndo.vue";
import Issues from "./components/Issues.vue";
import { HotKeyHandler } from "./store/hotkeys";

export default Vue.extend({
  name: "App",
  components: {
    MenuTop,
    MenuLeft,
    Grapher,
    MenuRight,
    MenuBottomTools,
    MenuBottomUndo,
    Issues,
  },
  created() {
    window.addEventListener("keydown", this.hotkey);
  },
  // make sure you remove the listener when the component is no longer visible
  destroyed() {
    window.removeEventListener("keydown", this.hotkey);
  },
  methods: {
    hotkey(event: KeyboardEvent) {
      HotKeyHandler(this.$store, event);
    },
  },
});
